import React from 'react';
import { useSelector } from 'react-redux';

import MobileFab from 'components/Layout/MobileShell/MobileFab';
import MobileListState from 'components/Layout/MobileShell/MobileListState';
import { selectMailerLayoutSearchQuery } from 'redux/reducers/mailerLayoutReducer';
import useMassEmailSorting from 'utils/hooks/mailer/useMassEmailSorting';
import useMassEmailListing from 'utils/hooks/mailer/useMassEmailListing';

import MassEmailCard from './MassEmailCard';

import './index.scss';

export default function MassEmailListingMobile({
  onNewClick,
}: {
  onNewClick: () => void,
}) {
  const searchTerms: string = useSelector(selectMailerLayoutSearchQuery);
  const [orderBy, orderDirection] = useMassEmailSorting();
  const {
    massEmailList,
    isLoading,
    isFetching,
    listEnded,
  } = useMassEmailListing({
    pageSize: 20,
    orderBy,
    orderDirection,
    searchTerms,
  });

  const resultsCount = massEmailList?.length || 0;

  return (
    <div className="mass-email-mobile">
      <MobileListState
        loading={isLoading}
        isEmpty={resultsCount === 0}
        emptyMessage="Não foi encontrado nenhum e-mail em massa."
        infiniteScroll={{ fetchingMore: isFetching, listEnded }}
      >
        {massEmailList?.map((massEmail) => (
          <MassEmailCard key={massEmail.id} massEmail={massEmail} />
        ))}
      </MobileListState>

      <MobileFab label="Novo e-mail em massa" onClick={onNewClick} />
    </div>
  );
}
